import React from "react";

import "../../../../Utils/Css//Menu.css";

export default function Menu() {
  return (
    <div className="menuContainer primary white">
      <div className="menuExchange">EXCHANGE</div>
      <div className="menuSymbol">SYMBOL</div>
      <div className="menuExpiry">EXPIRY</div>
      <div className="menuSymbol">MIN-QTY</div>
      <div className="menuSymbol">QTY-ORDER</div>
      <div className="menuSymbol">TOTAL-QTY</div>
      <div className="menuSymbol">LOT-SIZE</div>
      <div className="menuSymbol">MARGIN</div>
      <div className="menuSymbol">BID</div>
      <div className="menuSymbol">ASK</div>
      <div className="menuSymbol">LTP</div>
      <div className="menuSymbol addMore">ACTION</div>
    </div>
  );
}
